"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeSplitScheduleAccountingAmounts = computeSplitScheduleAccountingAmounts;
const handshake_xero_invoice_amounts_js_1 = require("./handshake-xero-invoice-amounts.js");
function roundMoney(n) {
    return Math.round(n * 100) / 100;
}
/** Aggregates per-tranche Handshake line amounts into schedule-level totals for split billing sync. */
function computeSplitScheduleAccountingAmounts(tranches) {
    const computed = tranches.map((tranche) => {
        const lineAmounts = (0, handshake_xero_invoice_amounts_js_1.computeHandshakeXeroInvoiceLineAmounts)({
            milestoneAmountCaptured: tranche.milestoneAmountCaptured,
            handshakeFeeAmountByBusinessCaptured: tranche.handshakeFeeAmountByBusinessCaptured,
            handshakeFeeAmountByClientCaptured: tranche.handshakeFeeAmountByClientCaptured,
        });
        return {
            projectInvoiceId: tranche.projectInvoiceId,
            ...lineAmounts,
        };
    });
    const scheduleInvoiceTotalAmount = roundMoney(computed.reduce((sum, row) => sum + row.invoiceTotalAmount, 0));
    const scheduleBusinessRevenueAmount = roundMoney(computed.reduce((sum, row) => sum + row.businessRevenueAmount, 0));
    const scheduleTotalHandshakeFeeAmount = roundMoney(computed.reduce((sum, row) => sum + row.totalHandshakeFeeAmount, 0));
    const scheduleMilestoneAmountCaptured = roundMoney(computed.reduce((sum, row) => sum + row.milestoneAmountCaptured, 0));
    return {
        tranches: computed,
        scheduleInvoiceTotalAmount,
        scheduleBusinessRevenueAmount,
        scheduleTotalHandshakeFeeAmount,
        scheduleMilestoneAmountCaptured,
    };
}
